import { useEffect, useState } from "react";
import { useToasts } from "react-toast-notifications";
import axios from "axios";
import UsersTable from "./users-table";
import "../../styles.css";
import './style.scss';
import './style.darkmode.scss';
import RolesSelect from "./roles-select";

const Users = () => {
    const perPage = 20;
    const { addToast } = useToasts();

    const [users, setUsers] = useState([]);
    const [page, setPage] = useState(1);
    const [isBusy, setBusy] = useState(false);
    const [total, setTotal] = useState(0);
    const [pageItems, setPageItems] = useState(0);
    const [role, setRole] = useState('');
    const [login, setLogin] = useState("");
    const [search, setSearch] = useState("");
    const [orderBy, setOrderBy] = useState({
        header: "login", //login, email, id, registered, subs, price, total earnings, referral income, pus, paid to pus, customer ID
        order: "ASC", // ASC OR DESC
    });

    const [rolesCount, setRolesCount] = useState({
        users: 0,
        subscribers: 0,
        admins: 0,
        pus: 0
    });
    const [searchBy, setSearchBy] = useState('login-email');
    const [fetchTrigger, setFetchTrigger] = useState(0);
    const [totals, setTotals] = useState({});
    const [ccVerified, setCcVerified] = useState(false);
    // useEffect(() => {
    //   getUsers();
    // }, [page, orderBy, search, role, searchBy]);

    useEffect(() => {
        let mounted = true;
        if (fetchTrigger > 0) {
            getUsers();
        }
        return () => {
            return mounted = false;
        };
    }, [fetchTrigger]);

    useEffect(() => {
        let mounted = true;
        getTotals();
        return () => {
            return mounted = false;
        };
    }, []);

    const getUsers = () => {
        setBusy(true);
        axios.get("/api/administration/users", {
            params: {
                page: page,
                per_page: perPage,
                login: login,
                header: orderBy.header,
                order: orderBy.order,
                role: role,
                searchBy,
                cc_verified: ccVerified
            },
        })
            .then((response) => {
                const data = response.data;
                setUsers(data.users);
                setTotal(data.total);
                setPageItems(Math.ceil(data.total / perPage));
                setBusy(false);
            })
            .catch((error) => {
                setBusy(false);
                console.log(error);
            });
    };

    const getTotals = () => {
        axios.get('/api/administration/users/totals')
            .then(response => {
                const data = response.data;
                setRolesCount({
                    ...rolesCount,
                    users: data.usersCount,
                    subscribers: data.susCount,
                    admins: data.adminCount,
                    pus: data.pusCount
                });
            });
    };

    return (
        <div className="admin-users">
            <h3 className="mb-4">Users</h3>
            <RolesSelect
                role={role}
                rolesCount={rolesCount}
                setRole={setRole}
            />
            <UsersTable
                users={users}
                orderBy={orderBy}
                page={page}
                total={total}
                login={login}
                isBusy={isBusy}
                pageItems={pageItems}
                setPage={setPage}
                setOrderBy={setOrderBy}
                setLogin={setLogin}
                setSearch={setSearch}
                getUsers={getUsers}
                setSearchBy={setSearchBy}
                searchBy={searchBy}
                fetchTrigger={fetchTrigger}
                setFetchTrigger={setFetchTrigger}
                setCcVerified={setCcVerified}
                ccVerified={ccVerified}
            />
        </div>
    );
};

export default Users;
